
import React, { useContext, useMemo, useRef, useState, useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import toast from 'react-hot-toast';
import axios from 'axios'
import TableComponent from '../../Components/CommonComponent/Table/Table';
import SaveButton from '../../Components/CommonComponent/Button/SaveButton';
import { FaEdit } from 'react-icons/fa';
import { RiDeleteBin6Fill } from 'react-icons/ri';
import { CommonContext } from '../../App';
import { useTranslation } from 'react-i18next';
import { v4 as uuidv4 } from 'uuid';
import CancelButton from '../../Components/CommonComponent/Button/CancelButton';
import ContactMarquee from '../../Components/CommonComponent/Table/ContactMarquee';
import api from '../../services/api';
import LoadingSpinner from '../../Components/CommonComponent/loadingSpiner/LoadingSpinner';
import DeleteDataModal from '../../Components/CommonComponent/Modals/DeleteDataModal';
import { getGlobalExpenseFilters } from '../../Components/CommonComponent/Modals/ShowTableFilterModal';

export default function SalesTable({ isModal = false, updatedDate, onModalClose, onModalSuccess, entry: modalEntry }) {
  const { t } = useTranslation();
  const heading = t("sales");

  const [salesData, setSalesData] = useState([]);
  const [transportationData, setTransportationData] = useState([]);
  const [loadingData, setLoadingData] = useState([]);
  const [finalData, setFinalData] = useState([]);
  const [resetKey, setResetKey] = useState(0);
  const [groupedData, setGroupedData] = useState([]);
  const [editingEntry, setEditingEntry] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingEntryKey, setEditingEntryKey] = useState(null);
  const { userData, branchId, setTotalSales, setSaleswithType, dateRange } = useContext(CommonContext);
  const adminId = userData?.user?.id;
  const userRole = userData?.user?.role;

  const [endDate, setEndDate] = useState(dateRange.endDate);
  const [isSaving, setIsSaving] = useState(false);

  const [allLedgers, setAllLedgers] = useState([]);
  const [ledgerData, setLedgerData] = useState([]);
  const [filtersLoaded, setFiltersLoaded] = useState(false);
  const [transportationLedgerData, setTransportationLedgerData] = useState([]);
  const [loadingLedgerData, setLoadingLedgerData] = useState([]);
  const [allGroups, setAllGroups] = useState([]);
  const [tableFilterModalOpen, setTableFilterModalOpen] = useState(false);

  const [pageLoading, setPageLoading] = useState(false);
  const [metaLoading, setMetaLoading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const LIMIT = 15;
  const [totalRecoard, setTotalRecoard] = useState(0);

const [tableFilters, setTableFilters] = useState(() => {
  const g = getGlobalExpenseFilters();
  return { transportation: g.salesTransportation, loadingUnloading: g.salesLoading };
});

  const [allPaymentData, setAllPaymentData] = useState([]);
  const [allSubGroups, setAllSubGroups] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedSales, setSelectedSales] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      const firstInput = document.querySelector('input[type="text"]');
      if (firstInput) firstInput.focus();
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setEndDate(dateRange.endDate);
  }, [dateRange.endDate,dateRange.startDate]);
  useEffect(() => {
  const handler = () => {
    const g = getGlobalExpenseFilters();
    setTableFilters({ transportation: g.salesTransportation, loadingUnloading: g.salesLoading });
  };
  window.addEventListener("global_expense_filters_updated", handler);
  return () => window.removeEventListener("global_expense_filters_updated", handler);
}, []);

  const navigate = useNavigate();
  const location = useLocation();
  const { entry: locationEntry, comeBack } = location.state || {};
  const entry = isModal ? modalEntry : locationEntry;

  const [lockedSalesFields, setLockedSalesFields] = useState({
    customerName: '',
    address: '',
    phone: '',
    ledgerId: '',
    ledgerGroup: '',
    ledgerSubGroup: ''
  });

  const [currentSalesItem, setCurrentSalesItem] = useState({
    typeOfBricks: '',
    quantity: '',
    unit: '',
    perQuantity: "",
  });

  const [areaData, setAreaData] = useState({
    customerArea: '',
    areaId: '',
    areaPrice: '',
    transportationRate: ''
  });

  const isInitialLoadRef = useRef(true);
  const isSettingDataRef = useRef(false);

  const fetchGroups = useCallback(async () => {
    if (!branchId) return;
    try {
      const res = await api.get(`groups-types/get-all-group?branchId=${branchId}`);
      if (res.data.success) setAllGroups(res.data.allData || []);
    } catch (err) {
      toast.error("Failed to fetch groups");
    } finally {
      setMetaLoading(false);
    }
  }, [branchId]);

  const fetchSubGroups = useCallback(async () => {
    if (!branchId) return;
    try {
      const res = await api.get(`groups-types/get-all-sub-group?branchId=${branchId}`);
      if (res.data.success) setAllSubGroups(res.data.allData || []);
    } catch (err) {
      toast.error("Failed to fetch subgroups");
    } finally {
      setMetaLoading(false);
    }
  }, [branchId]);

  const fetchLedgerData = useCallback(async () => {
    if (!branchId) return;
    try {
      const res = await api.get(`ledgers/get-all-ledger?branchId=${branchId}&isActive=1`);
      if (res.data.success) {
        setAllLedgers(res.data.allData || []);
        setLedgerData(res.data.allData || []);
        setTransportationLedgerData(res.data.allData || []);
        setLoadingLedgerData(res.data.allData || []);
      }
    } catch (err) {
      toast.error(err.message || "Failed to fetch ledgers");
    } finally {
      setMetaLoading(false);
    }
  }, [branchId, fetchGroups, fetchSubGroups]);

  const fetchPaymentAccount = useCallback(async () => {
    if (!branchId) return;
    try {
      const res = await api.get(`payment-structure/get-all-data?branchId=${branchId}`);
      if (res.data.success) setAllPaymentData(res.data.data || []);
    } catch (err) {
      toast.error(err.message || "Failed to fetch payment accounts");
    } finally {
      setMetaLoading(false);
    }
  }, [branchId]);

  useEffect(() => {
    if (!branchId) return;

    const loadMetaData = async () => {
      setMetaLoading(true);
      await Promise.all([
        fetchPaymentAccount(),
        fetchLedgerData(),
        fetchGroups(),
        fetchSubGroups()
      ]);
      setMetaLoading(false);
    };

    loadMetaData();
  }, [branchId]);


  useEffect(() => {
    if (!entry) return;

    setEditingEntry(entry);
    if(isModal){
      setIsEditMode(true);
    }
    setEditingEntryKey(entry.entry_key || entry.entryKey);

    isInitialLoadRef.current = true;
    isSettingDataRef.current = true;

    setSalesData(entry.sales || []);
    setTransportationData(entry.transportation || []);
    setLoadingData(entry.loading || []);

    if (entry.sales && entry.sales.length > 0) {
      setLockedSalesFields({
        customerName: entry.sales[0].customerName || '',
        address: entry.sales[0].address || '',
        phone: entry.sales[0].phone || ''
      });
    }

    setResetKey(prev => prev + 1);

    setTimeout(() => {
      isSettingDataRef.current = false;
    }, 200);
  }, [entry]);

  useEffect(() => {
    if (isEditMode && editingEntry) {
      isInitialLoadRef.current = true;
    }
  }, [isEditMode, editingEntry]);

  useEffect(() => {
    const fetchUpdateSales = async () => {
      if (!branchId || !entry?.entry_key) return;
      try {
        setPageLoading(true);
        const res = await api.get(`sales/get-sales-by-key?entry_key=${entry.entry_key}&branchId=${branchId}`);
        if (res.data.success) {
          isInitialLoadRef.current = true;
          isSettingDataRef.current = true;

          setIsEditMode(true);
          setEditingEntry(res.data);
          setEditingEntryKey(res.data.entryKey);
          setSalesData(res.data.sales || []);
          setTransportationData(res.data.transportation || []);
          setLoadingData(res.data.loading || []);

          if (res.data.sales && res.data.sales.length > 0) {
            setLockedSalesFields({
              customerName: res.data.sales[0].customerName || '',
              address: res.data.sales[0].address || '',
              phone: res.data.sales[0].phone || ''
            });
          }

          setTimeout(() => {
            isSettingDataRef.current = false;
          }, 200);
        }
      } catch (error) {
        toast.error("Failed to load updated sales data.");
        console.error(error);
      } finally {
        setPageLoading(false);
      }
    };

    fetchUpdateSales();
  }, [entry?.entry_key, branchId]);
const handleSalesDataChange = useCallback((data) => {
    setSalesData(data);
    
    if (data.length > 0) {
      const firstRow = data[0];

      const totalQuantity = data
        .filter(row => row.frontendDelete !== 0)
        .reduce((sum, row) => sum + (parseFloat(row.quantity) || 0), 0);

      const unit =
        firstRow?.typeOfBricks?.unit ||
        firstRow?.items?.unit ||
        firstRow.unit || '';

      const perQuantity =
        firstRow?.typeOfBricks?.perQuantity ||
        firstRow?.items?.perQuantity ||
        firstRow.perQuantity ||
        firstRow.per_quantity || '';

      setCurrentSalesItem({
        typeOfBricks: firstRow.typeOfBricks || '',
        quantity: totalQuantity.toString(),
        unit,
        perQuantity
      });

      setAreaData({
        customerArea: firstRow.areaName || firstRow.area || '',
        areaId: firstRow.areaId || '',
        areaPrice: firstRow.areaPrice || '',
        transportationRate: firstRow.transportationRate || firstRow.areaPrice || ''
      });

      const newLockedFields = {
        customerName: firstRow.customerName || '',
        address: firstRow.address || '',
        phone: firstRow.phone || '',
        ledgerId: firstRow.ledgerId || '',
        ledgerGroup: firstRow.ledgerGroup || '',
        ledgerSubGroup: firstRow.ledgerSubGroup || ''
      };
      setLockedSalesFields(prev =>
        JSON.stringify(prev) === JSON.stringify(newLockedFields) ? prev : newLockedFields
      );
     if (!firstRow.customerName && !firstRow.name) {
      setAreaData({
        customerArea: '',
        areaId: '',
        areaPrice: '',
        transportationRate: ''
      });
    }
      if (isSettingDataRef.current) return;

      const isInitialLoad = isInitialLoadRef.current;
      if (isInitialLoad) isInitialLoadRef.current = false;

      //  CRITICAL FIX: Always sync transportation and loading
      const syncWithSales = (prevData) => {
        if (prevData.length === 0) return prevData;
        return prevData.map((row, index) => {
          // Skip deleted rows
          if (row.frontendDelete === 0) return row;
          
          if (index === 0) {
            return {
              ...row,
              typeOfBricks: firstRow.typeOfBricks || row.typeOfBricks || '',
              unit: unit || '',
              perQuantity: perQuantity || '',
              quantity: totalQuantity.toString(),
            };
          }
          return {
            ...row,
            quantity: '0',
          };
        });
      };

      setTransportationData(prev => syncWithSales(prev));
      setLoadingData(prev => syncWithSales(prev));
    }
  }, [isEditMode]);

  const handleTransportationDataChange = useCallback((data) => {
    setTransportationData(data);
  }, []);

  const handleItemChange = useCallback((item, quantity, unit, unitId, itemInOut, rate, total, perQuantity) => {
    // Calculate total quantity excluding deleted rows
    const totalQty = salesData
      .filter(row => row.frontendDelete !== 0)
      .reduce((sum, row) => {
        const qty = parseFloat(row.quantity) || 0;
        return sum + qty;
      }, 0);

    setCurrentSalesItem({
      typeOfBricks: item,
      quantity: totalQty.toString(),
      unit: item?.unit || unit || '',
      perQuantity: item?.perQuantity || perQuantity || ''
    });

    // Update transportation table - in edit mode, only update quantity
    setTransportationData(prevData => {
      if (prevData.length === 0) return prevData;
      return prevData.map((row, idx) => {
        if (row.frontendDelete === 0) return row;
        if (idx === 0) {
          // In edit mode, only update quantity, keep other fields
          if (isEditMode) {
            return {
              ...row,
              quantity: totalQty.toString(),
            };
          }
          // In create mode, update all fields
          return {
            ...row,
            typeOfBricks: item,
            quantity: totalQty.toString(),
            unit: item?.unit || unit || '',
            perQuantity: item?.perQuantity || perQuantity || ''
          };
        }
        // For other rows, set quantity to 0
        return {
          ...row,
          quantity: '0'
        };
      });
    });

    // Update loading table - in edit mode, only update quantity
    setLoadingData(prevData => {
      if (prevData.length === 0) return prevData;
      return prevData.map((row, idx) => {
        if (row.frontendDelete === 0) return row;
        if (idx === 0) {
          // In edit mode, only update quantity, keep other fields
          if (isEditMode) {
            return {
              ...row,
              quantity: totalQty.toString(),
            };
          }
          // In create mode, update all fields
          return {
            ...row,
            typeOfBricks: item,
            quantity: totalQty.toString(),
            unit: item?.unit || unit || '',
            perQuantity: item?.perQuantity || perQuantity || ''
          };
        }
        // For other rows, set quantity to 0
        return {
          ...row,
          quantity: '0'
        };
      });
    });
  }, [salesData, isEditMode]);

  const handleLoadingDataChange = useCallback((data) => {
    setLoadingData(data);
  }, []);
  // SalesTable.jsx mein ye useEffect add karo
useEffect(() => {
  if (!areaData.areaPrice) return;
  if (!tableFilters.transportation) return;

  setTransportationData(prev => {
    if (prev.length === 0) return prev;
    return prev.map((row, idx) => {
      if (row.frontendDelete === 0) return row;

      const rate = parseFloat(areaData.areaPrice) || 0;
      const quantity = parseFloat(row.quantity || currentSalesItem.quantity) || 0;
      const perQty = parseFloat(row.perQuantity || currentSalesItem.perQuantity) || 1;
      const total = rate && quantity ? (rate * quantity) / perQty : '';

      return {
        ...row,
        rate: areaData.areaPrice,
        total: total || '',
        areaId: areaData.areaId || '',
        areaName: areaData.customerArea || '',
        areaPrice: areaData.areaPrice || '',
        transportationRate: areaData.transportationRate || '',
      };
    });
  });
}, [areaData.areaPrice, areaData.areaId]);
useEffect(() => {
  // Agar areaPrice clear ho gaya → transportation rate bhi clear karo
  if (areaData.areaPrice) return;

  setTransportationData(prev => {
    if (prev.length === 0) return prev;
    return prev.map(row => {
      if (row.frontendDelete === 0) return row;
      return {
        ...row,
        rate: '',
        total: '',
        areaId: '',
        areaName: '',
        areaPrice: '',
        transportationRate: '',
      };
    });
  });
}, [areaData.areaPrice]);

  const salesColumns = useMemo(() => ([
    { header: t('customer'), placeholder: 'customerName', inputType: 'input', active: true, filteration: true, locked: true, combined: true, type: 'text',uniqueId:"#customer" },
    { header: t('address'), placeholder: 'address', inputType: 'input', active: true, locked: true, combined: true, type: 'text',uniqueId:"#address" },
    { header: t('phone'), placeholder: 'phone', inputType: 'input', active: true, locked: true, combined: true, type: 'text',uniqueId:"#phone" },
    { header: t('item'), placeholder: 'typeOfBricks', inputType: 'dropdown', options: [], active: true, filteration: true, type: 'text',uniqueId:"#items",columnPart: "Stock" },
    { header: t('quantity'), placeholder: 'quantity', inputType: 'input', active: true, showUnit: true, type: 'number',uniqueId:"#quantity" },
    { header: t('unit'), placeholder: 'unit', inputType: 'input', active: false, type: 'text',uniqueId:"#unit" },
    { header: t('rate'), placeholder: 'rate', inputType: 'input', active: true, type: 'number',uniqueId:"#rate" },
    { header: t('total'), placeholder: 'total', inputType: 'input', active: true, type: 'number' ,uniqueId:"#total"},
    { header: t('description'), placeholder: 'description', inputType: 'input', active: true, type: 'text',uniqueId:"#description" },
    { header: t('paymentType'), placeholder: 'paymentType', inputType: 'dropdown', options: [], active: true, addDropDownOptions: true, type: 'text',uniqueId:"#paymentype" },
    { header: t('received'), placeholder: 'received', inputType: 'input', active: true, type: 'number',uniqueId:"#received" },
    isEditMode && { header: t('reason'), placeholder: 'reason', inputType: 'input', active: true, type: 'text',uniqueId:"#reason" },
  ]), [t, isEditMode]);

  const transportationColumns = useMemo(() => ([
    { header: t('name'), placeholder: 'name', inputType: 'input', active: true, filteration: true, combined: true, type: 'text',uniqueId:"#name" },
    { header: t('address'), placeholder: 'address', inputType: 'input', active: true, combined: true, type: 'text',uniqueId:"#address" },
    { header: t('phone'), placeholder: 'phone', inputType: 'input', active: true, combined: true, type: 'text',uniqueId:"#phone" },
    { header: t('quantity'), placeholder: 'quantity', inputType: 'input', active: true, showUnit: true, type: 'number' ,uniqueId:"#quantity"},
    { header: t('unit'), placeholder: 'unit', inputType: 'input', active: false, type: 'text' ,uniqueId:"#unit"},
    { header: t('rate'), placeholder: 'rate', inputType: 'input', active: true, type: 'number' ,uniqueId:"#rate"},
    { header: t('total'), placeholder: 'total', inputType: 'input', active: true, type: 'number',uniqueId:"#total" },
    { header: t('description'), placeholder: 'description', inputType: 'input', active: true, type: 'text' ,uniqueId:"#description"},
    { header: t('paymentType'), placeholder: 'paymentType', inputType: 'dropdown', options: [], active: true, addDropDownOptions: true, type: 'text' ,uniqueId:"#paymentType"},
    { header: t('paid'), placeholder: 'paid', inputType: 'input', active: true, type: 'number',uniqueId:"#paid" },
    { header: t('part'), placeholder: 'part', inputType: 'input', status: 'auto', defaultValue: 'sales', active: true, type: 'text',uniqueId:"#part" },
    isEditMode && { header: t('reason'), placeholder: 'reason', inputType: 'input', active: true, type: 'text',uniqueId:"#reason" },
  ]), [t, isEditMode]);

  const loadingColumns = useMemo(() => ([
    { header: t('name'), placeholder: 'name', inputType: 'input', active: true, filteration: true, combined: true, type: 'text',uniqueId:"#name" },
    { header: t('address'), placeholder: 'address', inputType: 'input', active: true, combined: true, type: 'text',uniqueId:"#address" },
    { header: t('phone'), placeholder: 'phone', inputType: 'input', active: true, combined: true, type: 'text' ,uniqueId:"#phone"},
    { header: t('quantity'), placeholder: 'quantity', inputType: 'input', active: true, showUnit: true, type: 'number',uniqueId:"#quantity" },
    { header: t('unit'), placeholder: 'unit', inputType: 'input', active: false, type: 'text',uniqueId:"#unit" },
    { header: t('rate'), placeholder: 'rate', inputType: 'input', active: true, type: 'number' ,uniqueId:"#rate"},
    { header: t('total'), placeholder: 'total', inputType: 'input', active: true, type: 'number' ,uniqueId:"#total"},
    { header: t('description'), placeholder: 'description', inputType: 'input', active: true, type: 'text',uniqueId:"#description" },
    { header: t('paymentType'), placeholder: 'paymentType', inputType: 'dropdown', options: [], active: true, addDropDownOptions: true, type: 'text',uniqueId:"#paymentType" },
    { header: t('paid'), placeholder: 'paid', inputType: 'input', active: true, type: 'number' ,uniqueId:"#paid"},
    { header: t('part'), placeholder: 'part', inputType: 'input', status: 'auto', defaultValue: 'sales', active: true, type: 'text',uniqueId:"#part" },
    isEditMode && { header: t('reason'), placeholder: 'reason', inputType: 'input', active: true, type: 'text',uniqueId:"#reason" },
  ]), [t, isEditMode]);

  const visibleSalesColumns = useMemo(
    () => salesColumns.filter(c => c.active && c.status !== 'auto'),
    [salesColumns]
  );
  const visibleTransportationColumns = useMemo(
    () => transportationColumns.filter(c => c.active && c.status !== 'auto'),
    [transportationColumns]
  );
  const visibleLoadingColumns = useMemo(
    () => loadingColumns.filter(c => c.active && c.status !== 'auto'),
    [loadingColumns]
  );


  const addAutoFields = useCallback((data, columns) => {
    const autoCols = columns.filter(col => col.status === 'auto');
    return data.map(row => {
      const updated = { ...row };
      autoCols.forEach(col => {
        updated[col.placeholder] = col.defaultValue;
      });
      return updated;
    });
  }, []);

  const ledgerGroupMappingSales = {
    customerName: "Debtors",
    typeOfBricks: "Bricks",
    paymentType: "Current Assets",
  };
  const ledgerGroupMappingTransporte = {
    customerName: "Vehicle",
    typeOfBricks: "Bricks",
    paymentType: "Current Assets",
  };
  const ledgerGroupMappingLoading = {
    customerName: "Labour",
    typeOfBricks: "Bricks",
    paymentType: "Current Assets",
  };

  const allSavedSalesRows = useMemo(() =>
    finalData.flatMap(entry => entry.sales || []),
    [finalData]
  );
  const allSavedloadingRows = useMemo(() =>
    finalData.flatMap(entry => entry.loading || []),
    [finalData]
  );
  const allSavedTransporteRows = useMemo(() =>
    finalData.flatMap(entry => entry.transportation || []),
    [finalData]
  );

  const handleSave = useCallback(async () => {
    const entryKey = isEditMode ? editingEntryKey : uuidv4();
    setIsSaving(true);

    try {
      const currentSelectedDate = updatedDate || dateRange.endDate;
      setEndDate(currentSelectedDate);  
      
      // Include ALL rows, even deleted ones (with frontendDelete marker)
      const salesWithAuto = addAutoFields(salesData, salesColumns).map(item => ({
        ...item,
        customerName: lockedSalesFields.customerName,
        address: lockedSalesFields.address,
        phone: lockedSalesFields.phone,
        ledgerId: item.ledgerId || lockedSalesFields.ledgerId,
        ledgerGroup: item.ledgerGroup || lockedSalesFields.ledgerGroup,
        ledgerSubGroup: item.ledgerSubGroup || lockedSalesFields.ledgerSubGroup,
        entry_key: entryKey,
        branchId,
        ...(item.frontendDelete === 0 && { frontendDelete: 0 }), // Include frontendDelete marker
      }));

      const transWithAuto = addAutoFields(transportationData, transportationColumns).map(item => ({
        ...item,
        entry_key: entryKey,
        branchId,
        per_quantity: item.perQuantity || item.per_quantity || currentSalesItem.perQuantity || '',
        unit: item.unit || currentSalesItem.unit || "",
        ...(item.frontendDelete === 0 && { frontendDelete: 0 }),
      }));

      const loadWithAuto = addAutoFields(loadingData, loadingColumns).map(item => ({
        ...item,
        entry_key: entryKey,
        branchId,
        per_quantity: item.perQuantity || item.per_quantity || currentSalesItem.perQuantity || '',
        unit: item.unit || currentSalesItem.unit || "",
        ...(item.frontendDelete === 0 && { frontendDelete: 0 }),
      }));

      if (isEditMode) {
        const payload = {
          entryDate: currentSelectedDate,
          entryKey,
          sales: salesWithAuto,
          transportation: transWithAuto,
          loading: loadWithAuto,
          branchId,
          adminId
        };

        const updateRes = await api.post(`sales/update-sales-entry`, payload);

        if (updateRes.data.success) {
          if (updateRes.data.data) {
            setFinalData(prev =>
              prev.map(entry =>
                entry.entryKey === entryKey ? { ...entry, ...updateRes.data.data } : entry
              )
            );
            setGroupedData(prev =>
              prev.map(entry =>
                entry.entryKey === entryKey ? { ...entry, ...updateRes.data.data } : entry
              )
            );
          }

          toast.success("Data updated successfully!");
          setEndDate(currentSelectedDate);  

          await fetchRealData(1, true, currentSelectedDate);
          await fetchFinalData();

          if (isModal && onModalSuccess) {
            onModalSuccess();
            refreshTable();
            fetchFinalData();
          } else if (comeBack) {
            navigate(comeBack, { state: { entry: updateRes.data.data.sales[0] } });
          }
        }
      } else {
        const payload = {
          entryDate: currentSelectedDate,
          entryKey,
          sales: salesWithAuto,
          transportation: transWithAuto,
          loading: loadWithAuto,
          branchId
        };

        const createRes = await api.post(`sales/create-sales-entry`, payload);

        if (createRes.data.success) {
          toast.success('Data saved successfully!');
          setEndDate(currentSelectedDate);  

          await fetchRealData(1, true, currentSelectedDate);
          await fetchFinalData();

          if (isModal && onModalSuccess) {
            onModalSuccess();
            refreshTable();
            fetchFinalData();
          } else if (comeBack) {
            navigate(comeBack, { state: { entry } });
          }
        }
      }

      if (isEditMode) {
        await handleCancelEdit();
      } else {
        setResetKey(prev => prev + 1);
        setLockedSalesFields({
          customerName: '',
          address: '',
          phone: '',
          ledgerId: '',
          ledgerGroup: '',
          ledgerSubGroup: ''
        });
      }

      setTimeout(() => {
        const firstInput = document.querySelector('input[type="text"]');
        if (firstInput) firstInput.focus();
      }, 100);

    } catch (error) {
      const backendMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        "Failed to save data.";
      toast.error(backendMessage);
      console.error(error);
    } finally {
      setIsSaving(false);
    }
  }, [
    isEditMode,
    editingEntryKey,
    updatedDate,
    dateRange.endDate,
    salesData,
    transportationData,
    loadingData,
    lockedSalesFields,
    addAutoFields,
    salesColumns,
    transportationColumns,
    loadingColumns,
    currentSalesItem,
    branchId,
    adminId,
    isModal,
    onModalSuccess,
    navigate,
    comeBack
  ]);

  const fetchRealData = useCallback(async (pageNum = 1, reset = false, customDate = null) => {
    const dateToUse = customDate || endDate;

    if (!branchId || !dateToUse) return;

    try {
      pageNum === 1 ? setPageLoading(true) : setLoadingMore(true);

      const res = await api.get(
        `sales/get-sales-entry?branchId=${branchId}&date=${dateToUse}&page=${pageNum}&limit=${LIMIT}&order=desc`
      );

      if (res.data.success) {
        const newData = res.data.entries || [];
        setTotalRecoard(res.data.total);
        setGroupedData(prev => (reset ? newData : [...prev, ...newData]));
        setHasMore(newData.length === LIMIT);
      }
    } catch (error) {
      toast.error("Failed to load consolidated data.");
      console.error(error);
    } finally {
      setPageLoading(false);
      setLoadingMore(false);
    }
  }, [branchId, endDate]);


  const fetchFinalData = useCallback(async () => {
    if (!branchId) return;
    try {
      setMetaLoading(true);
      const res = await api.get(`sales/get-all-sales?branchId=${branchId}`);
      if (res.data.success) {
        setFinalData(res.data.entries || []);
        setTotalSales(res.data.totalQuantity || 0);
        setSaleswithType(res.data.quantityByTypeOfBricks || []);
      }
    } catch (error) {
      toast.error("Failed to load consolidated data.");
      console.error(error);
    } finally {
      setMetaLoading(false);
    }
  }, [branchId, setTotalSales, setSaleswithType]);

  useEffect(() => {
    if (branchId && endDate) {
      setPage(1);
      setHasMore(true);
      fetchRealData(1, true);
    }
  }, [branchId, endDate, fetchRealData]);

  useEffect(() => {
    if (branchId) {
      fetchFinalData()
    }
  }, [branchId, fetchFinalData])

  const refreshTable = (customDate = null) => {
    setPage(1);
    setHasMore(true);
    fetchRealData(1, true, customDate);
  };


  const handleScroll = async (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 20 && hasMore && !loadingMore) {
      await fetchRealData(page + 1);
      setPage(prev => prev + 1);
    }
  };

  const handleEditEntry = useCallback((entry) => {
    setEditingEntry(entry);
    setIsEditMode(true);
    setEditingEntryKey(entry.entryKey);

    isInitialLoadRef.current = true;
    isSettingDataRef.current = true;

    setSalesData(entry.sales?.reverse() || []);
    setTransportationData(entry.transportation?.reverse() || []);
    setLoadingData(entry.loading?.reverse() || []);

    if (entry.sales && entry.sales.length > 0) {
      setLockedSalesFields({
        customerName: entry.sales[0].customerName || '',
        address: entry.sales[0].address || '',
        phone: entry.sales[0].phone || ''
      });
    }

    setResetKey(prev => prev + 1);

    setTimeout(() => {
      isSettingDataRef.current = false;
    }, 300);
  }, []);

  const handleCancelEdit = useCallback(() => {
    return new Promise(resolve => {
      setEditingEntry(null);
      setIsEditMode(false);
      setEditingEntryKey(null);
      setSalesData([]);
      setTransportationData([]);
      setLoadingData([]);
      setLockedSalesFields({
        customerName: '',
        address: '',
        phone: ''
      });
      setResetKey(prev => prev + 1);

      if (isModal && onModalClose) {
        onModalClose();
      } else if (comeBack) {
        navigate(comeBack, { state: { entry } });
      }

      setTimeout(() => {
        const firstInput = document.querySelector('input[type="text"]');
        if (firstInput) firstInput.focus();
        resolve();
      }, 0);
    });
  }, [isModal, onModalClose, comeBack, navigate, entry]);

  const handleDeleteSalesApi = async (entry) => {
    try {
      setPageLoading(true);
      const res = await api.post("sales/delete-sales-entry", {
        entryKey: entry.entryKey,
        branchId,
        adminId,
        role: userRole,
        deleteReason: entry.deleteReason,
        deletePassword: entry.deletePassword,
        entry
      });

      if (res.data.success) {
        toast.success("Sales entry deleted successfully");
        setShowDeleteModal(false);
        setSelectedSales(null);
        refreshTable();
        fetchFinalData();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Delete failed");
    } finally {
      setPageLoading(false);
    }
  };

  const hasSales = groupedData.some(entry => entry.sales?.length > 0);
  const hasTransportation = groupedData.some(entry => entry.transportation?.length > 0);
  const hasLoading = groupedData.some(entry => entry.loading?.length > 0);

  const showSales = hasSales;
  const showTransportation = hasTransportation;
  const showLoading = hasLoading;

  return (
    <div className="text-center relative">
      <div className="w-full">

        <div className='pt-2'>
          <TableComponent
            columns={visibleSalesColumns}
            onUpdateData={fetchLedgerData}
            allLedgers={allLedgers}
            allPaymentData={allPaymentData}
            updatePaymentAccount={fetchPaymentAccount}
            setAllLedgers={setAllLedgers}
            ledgerData={ledgerData}
            setLedgerData={setLedgerData}
            allGroups={allGroups}
            allSubGroups={allSubGroups}
            setAllGroups={setAllGroups}
            setAllSubGroups={setAllSubGroups}
            heading={t("sales")}
            tableUniqueId='#sales_table'
            tableFilteration={true}
            uniqueForFilter="salesData_sales"
            onDataChange={handleSalesDataChange}
            resetTrigger={resetKey}
            allowMultiple={true}
            suggestionsData={allSavedSalesRows}
            firstInputPlaceholder="customerName"
            finalData={finalData}
            calculateTotal={true}
            perQuantityRate="1000"
            field="customerName"
            defaultLedgerGroup="Sales"
            columnLedgerGroups={ledgerGroupMappingSales}
            lockedFields={lockedSalesFields}
            changeDesignHeading={false}
            isMasterTable={true}
            tableFilterModalOpen={tableFilterModalOpen}
            setTableFilterModalOpen={setTableFilterModalOpen}
            tableFilters={tableFilters}
            setTableFilters={setTableFilters}
            setFiltersLoaded={setFiltersLoaded}
            syncedUnit={currentSalesItem.unit}
            filtersLoaded={filtersLoaded}
            isSettingDataRef={isSettingDataRef}
            isEditMode={isEditMode}
            showValidationError={(message) => toast.error(message)}
             skipItemValidation={true} 
            onFilterUpdate={() => {
              setTransportationLedgerData([...ledgerData]);
              setLoadingLedgerData([...ledgerData]);
            }}
            onItemChange={handleItemChange}
            onAreaDataChange={(areaInfo) => {
              setAreaData({
                customerArea: areaInfo.areaName || '',
                areaId: areaInfo.areaId || '',
                areaPrice: areaInfo.areaPrice || '',
                transportationRate: areaInfo.transportationRate || areaInfo.areaPrice || ''
              });
            }}
            onLastInputEnter={() => {
              setTimeout(() => {
                const buttons = document.querySelectorAll('button');
                const saveBtn = Array.from(buttons).find(btn =>
                  btn.textContent.toLowerCase().includes('save') ||
                  btn.textContent.toLowerCase().includes('processing')
                );
                if (saveBtn) saveBtn.focus();
              }, 100);
            }}
            {...(editingEntry ? { initialData: editingEntry.sales } : {})}
          />
        </div>

        {tableFilters.transportation && (
          <div className='pt-1'>
            <TableComponent
              columns={visibleTransportationColumns}
              onUpdateData={fetchLedgerData}
              allLedgers={allLedgers}
              allPaymentData={allPaymentData}
              updatePaymentAccount={fetchPaymentAccount}
              setAllLedgers={setAllLedgers}
              ledgerData={ledgerData}
              setLedgerData={setLedgerData}
              allGroups={allGroups}
              allSubGroups={allSubGroups}
              setAllGroups={setAllGroups}
              setAllSubGroups={setAllSubGroups}
              heading={t("transportation")}
              tableUniqueId='#sales_transportaton_table'
              tableFilteration={false}
              uniqueForFilter="salesData_transportation"
              onDataChange={handleTransportationDataChange}
              resetTrigger={resetKey}
              allowMultiple={true}
              calculateTotal={true}
              perQuantityRate="1000"
              part="sales"
              suggestionsData={allSavedTransporteRows}
              finalData={finalData}
              firstInputPlaceholder="name"
              field="name"
              changeDesignHeading={false}
              defaultLedgerGroup="Vehicle"
              columnLedgerGroups={ledgerGroupMappingTransporte}
              areaBasedRate={areaData}
              autoFillRate={true}
              setFiltersLoaded={setFiltersLoaded}
              filtersLoaded={filtersLoaded}
              syncedItem={currentSalesItem.typeOfBricks}
              syncedQuantity={currentSalesItem.quantity}
              syncedUnit={currentSalesItem.unit}
              syncedPerQuantity={currentSalesItem.perQuantity}
              isSettingDataRef={isSettingDataRef}
              isEditMode={isEditMode}
              showValidationError={(message) => toast.error(message)}
               skipItemValidation={true} 
              {...(editingEntry ? { initialData: editingEntry.transportation } : {})}
            />
          </div>
        )}

        {tableFilters.loadingUnloading && (
          <div className='pt-1'>
            <TableComponent
              columns={visibleLoadingColumns}
              onUpdateData={fetchLedgerData}
              allLedgers={allLedgers}
              allPaymentData={allPaymentData}
              updatePaymentAccount={fetchPaymentAccount}
              setAllLedgers={setAllLedgers}
              ledgerData={ledgerData}
              setLedgerData={setLedgerData}
              allGroups={allGroups}
              allSubGroups={allSubGroups}
              setAllGroups={setAllGroups}
              setAllSubGroups={setAllSubGroups}
              heading={t("loading/unloading")}
              tableUniqueId='#sales_loading_table'
              tableFilteration={false}
              uniqueForFilter="salesData_loading"
              onDataChange={handleLoadingDataChange}
              resetTrigger={resetKey}
              allowMultiple={true}
              calculateTotal={true}
              perQuantityRate="1000"
              part="sales"
              suggestionsData={allSavedloadingRows}
              firstInputPlaceholder="name"
              finalData={finalData}
              changeDesignHeading={false}
              field="name"
              setFiltersLoaded={setFiltersLoaded}
              filtersLoaded={filtersLoaded}
              defaultLedgerGroup="Labours"
              columnLedgerGroups={ledgerGroupMappingLoading}
              syncedItem={currentSalesItem.typeOfBricks}
              syncedQuantity={currentSalesItem.quantity}
              syncedUnit={currentSalesItem.unit}
              syncedPerQuantity={currentSalesItem.perQuantity}
              isSettingDataRef={isSettingDataRef}
              isEditMode={isEditMode}
              showValidationError={(message) => toast.error(message)}
               skipItemValidation={true} 
              {...(editingEntry ? { initialData: editingEntry.loading } : {})}
            />
          </div>
        )}

        <div className='flex justify-end gap-2 mt-2'>
          <CancelButton onClick={handleCancelEdit} text={t('cancel')} />
          <SaveButton
            onClick={(e) => {
              if (e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter')) {
                handleSave();
              }
            }}
            text={isSaving ? t('processing') : t('save')}
            disabled={isSaving}
            className="save-button"
          />
        </div>

        {pageLoading && (
          <div className="absolute inset-0 flex justify-center items-center bg-white/70 z-50">
            <LoadingSpinner size={70} color="#be8024" />
          </div>
        )}

        {!pageLoading && !isModal && !onModalClose &&
          (groupedData.length > 0 ? (
            <div>
              <div
                className="overflow-x-auto lg:overflow-visible mt-2 max-h-[80vh] overflow-y-auto relative custom-scrollbar"
                onScroll={handleScroll}
              >
                <table className="w-full table-auto border-collapse">

                  <thead className='sticky top-0 z-20 bg-theme-headerBg'>
                    <tr className="bg-theme-headerBg text-white">
                      <th colSpan={(showTransportation || showLoading) ? "4" : "5"} className="border-e py-[2px] text-center font-medium text-sm">
                        {t('sales')}
                      </th>

                      {showTransportation && (
                        <th colSpan={showTransportation && !showLoading ? "4" : "3"} className="border-e text-center font-medium text-sm">
                          {t('transportation')}
                        </th>
                      )}

                      {showLoading && (
                        <th colSpan={4} className="text-center font-medium text-sm">
                          {t('loading/unloading')}
                        </th>
                      )}
                    </tr>

                    <tr className="text-theme-headerBg bg-white border-b border-theme-headerBg">
                      <th className="border-b border-e px-1 text-center font-medium text-sm">{t("srNumber")}</th>
                      <th className="px-1 border-b text-start font-medium text-sm">{t('customerInfo')}</th>
                      <th className="px-1 border-b text-center font-medium text-sm">
                        {t('qty')} {t('unit')} {t('item')} @ {t('rate')} {t('perQty')} = {t('total')}
                      </th>
                      <th className="px-1 border-b border-e text-center font-medium text-sm">
                        {t('received')} ({t('paymentType')})
                      </th>

                      {showTransportation && (
                        <>
                          <th className="px-1 border-b text-start font-medium text-sm w-28">{t('vehicle')}</th>
                          <th className="px-1 border-b text-center font-medium text-sm">
                            {t('qty')} {t('unit')} {t('item')} @ {t('rate')} {t('perQty')} = {t('total')}
                          </th>
                          <th className="px-1 border-b border-e text-center font-medium text-sm">
                            {t('paid')} ({t('paymentType')})
                          </th>
                        </>
                      )}

                      {showLoading && (
                        <>
                          <th className="px-1 border-b text-start font-medium text-sm w-28">{t('name')}</th>
                          <th className="px-1 border-b text-center font-medium text-sm">
                            {t('qty')} {t('unit')} {t('item')} @ {t('rate')} {t('perQty')} = {t('total')}
                          </th>
                          <th className="px-1 border-b border-e text-center font-medium text-sm">
                            {t('paid')} ({t('paymentType')})
                          </th>
                        </>
                      )}

                      <th className="border-b px-1 text-center font-medium text-sm">
                        {t('actions')}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {groupedData.map((entry, idx) => {
                      const maxRows = Math.max(
                        entry.sales.length || 1,
                        entry.transportation?.length || 1,
                        entry.loading?.length || 1
                      );

                      return [...Array(maxRows)].map((_, rowIndex) => {
                        const sale = entry.sales[rowIndex];
                        const transport = entry.transportation?.[rowIndex];
                        const load = entry.loading?.[rowIndex];

                        return (
                          <tr key={`${entry.entryKey}-${rowIndex}`} className="bg-white">

                            {rowIndex === 0 && (
                              <td
                                rowSpan={maxRows}
                                className="text-center border-b border-s border-gray-200 font-bold align-middle text-sm"
                              >
                                {totalRecoard - idx}
                              </td>
                            )}

                            {rowIndex === 0 && (
                              <td
                                rowSpan={maxRows}
                                className="break-words text-sm border-b border-s border-gray-200"
                              >
                                {entry.sales.length > 0 && (
                                  <div className="text-sm flex flex-col">
                                    <div
                                      className="text-center p-0 cursor-pointer capitalize"
                                      title="Check account details"
                                      onClick={() => {
                                        navigate("/account-books/ledger-details", {
                                          state: {
                                            salesRegister: entry.sales[0],
                                            comeBack: "/dashboard/sales-table",
                                          },
                                        });
                                      }}
                                    >
                                      <div className="flex gap-2 justify-center w-32 capitalize fw-medium">
                                        <ContactMarquee
                                          firstName={entry.sales[0].customer_name}
                                          secondName={entry.sales[0].cousinName}
                                        />
                                      </div>
                                      <div className="flex gap-2 justify-center w-32 capitalize">
                                        <ContactMarquee
                                          firstName={entry.sales[0].ledgerSubGroup}
                                          secondName={entry.sales[0].subGroupNameInHindi}
                                        />
                                      </div>
                                    </div>
                                    <div className="p-0 text-gray-600 text-nowrap w-32 overflow-x-scroll capitalize custom-scrollbar cursor-pointer">
                                      <ContactMarquee
                                        firstName={entry.sales[0].phone}
                                        secondName={entry.sales[0].address}
                                      />
                                    </div>
                                         <div className="flex my-[2px] px-[2px]">
                                    <span className={`text-xs font-semibold px-2 py-[1px] rounded bg-theme-tableHoverColor text-theme-sidebarBg`}>
                                    Bal: ₹ {Number(entry.sales[0].balance.closing_balance).toLocaleString('en-IN')} {entry.sales[0].balance.closing_balance !== 0 ? `(${entry.sales[0].balance.closing_balance_type})` :""} 
                                    </span>
                                </div>
                                  </div>
                                )}
                              </td>
                            )}

                            <td className="border-b border-gray-200 text-center text-sm p-0">
                              {sale && (
                                <>
                                  {sale.quantity > 0 &&  Number(sale.quantity).toLocaleString("en-US", { maximumFractionDigits: 0 })}{" "}
                                  {sale.quantity > 0 && sale.unit} {sale.typeOfBricks?.name} {sale.quantity > 0 && "@"}  
                                  {sale.quantity > 0 && Number(sale.rate).toLocaleString("en-US", { maximumFractionDigits: 0 })}
                                   { sale.quantity > 0 && sale.rate && "/"}
                                  {sale.quantity > 0 && Number(sale.per_quantity).toLocaleString("en-US", { maximumFractionDigits: 0 })}{" "}
                                  {sale.quantity > 0 && " = "}
                                  {sale.quantity > 0 && Number(sale.total).toLocaleString("en-US", { maximumFractionDigits: 0 })}
                                </>
                              )}
                            </td>

                            <td className="border-b border-gray-200 text-center text-sm p-0">
                              {sale && (
                                <>
                                  {Number(sale.received).toLocaleString("en-US", { maximumFractionDigits: 0 })}{" "}
                                  {sale.received > 0 && sale.paymentType && `(${sale.paymentType.name})`}
                                </>
                              )}
                            </td>

                            {showTransportation && (
                              <>
                                <td
                                  className="border-b border-gray-200 border-s text-center text-sm cursor-pointer"
                                  title="Check account details"
                                >
                                  {transport && (
                                    <div
                                      onClick={() => {
                                        navigate("/account-books/ledger-details", {
                                          state: {
                                            salesRegister: transport,
                                            comeBack: "/dashboard/sales-table",
                                          },
                                        });
                                      }}
                                    >
                                      <div className="flex gap-2 justify-center w-32 capitalize fw-medium">
                                        <ContactMarquee
                                          firstName={transport.name}
                                          secondName={transport.cousinName}
                                        />
                                      </div>
                                      <div className="flex gap-2 justify-center px-1 w-32 capitalize">
                                        <ContactMarquee
                                          firstName={transport.ledgerSubGroup}
                                          secondName={transport.subGroupNameInHindi}
                                        />
                                      </div>
                                      <div className="p-0 text-gray-600 w-32 text-nowrap overflow-x-scroll capitalize custom-scrollbar cursor-pointer">
                                        <ContactMarquee
                                          firstName={transport.phone}
                                          secondName={transport.address}
                                        />
                                      </div>
                                           <div className="flex my-[2px] px-[2px]">
                                    <span className={`text-xs font-semibold px-2 py-[1px] rounded bg-theme-tableHoverColor text-theme-sidebarBg`}>
                                    Bal: ₹ {Number(transport.balance.closing_balance).toLocaleString('en-IN')} {transport.balance.closing_balance !== 0 ? `(${transport.balance.closing_balance_type})` :""} 
                                    </span>
                                </div>
                                    </div>
                                  )}
                                </td>

                                <td className="border-b border-gray-200 text-center text-sm p-0">
                                  {transport && (
                                    <>
                                      {transport.quantity > 0 && Number(transport.quantity).toLocaleString("en-US", { maximumFractionDigits: 0 })}{" "}
                                      {transport.quantity > 0 && transport.unit}  {transport.quantity > 0 && transport.typeOfBricks?.name} {transport.quantity > 0 &&  " @ "}
                                      {transport.quantity > 0 && Number(transport.rate).toLocaleString("en-US", { maximumFractionDigits: 0 })}
                                      {transport.quantity > 0 && transport.rate && "/"}
                                      {transport.quantity > 0 && Number(transport.per_quantity).toLocaleString("en-US", { maximumFractionDigits: 0 })}{" "}
                                      {transport.quantity > 0 && " = "}
                                      {transport.quantity > 0 &&  Number(transport.total).toLocaleString("en-US", { maximumFractionDigits: 0 })}
                                    </>
                                  )}
                                </td>

                                <td className="border-b border-gray-200 text-center text-sm p-0">
                                  {transport && (
                                    <>
                                      {Number(transport.paid).toLocaleString("en-US", { maximumFractionDigits: 0 })}{" "}
                                      {transport.paid > 0 && transport.paymentType && `(${transport.paymentType.name})`}
                                    </>
                                  )}
                                </td>
                              </>
                            )}

                            {showLoading && (
                              <>
                                <td
                                  className="border-b border-s border-gray-200 text-center text-sm cursor-pointer"
                                  title="Check account details"
                                >
                                  {load && (
                                    <div
                                      onClick={() => {
                                        navigate("/account-books/ledger-details", {
                                          state: {
                                            salesRegister: load,
                                            comeBack: "/dashboard/sales-table",
                                          },
                                        });
                                      }}
                                    >
                                      <div className="flex gap-2 justify-center w-32 capitalize fw-medium">
                                        <ContactMarquee
                                          firstName={load.name}
                                          secondName={load.cousinName}
                                        />
                                      </div>
                                      <div className="flex gap-2 justify-center w-32 capitalize">
                                        <ContactMarquee
                                          firstName={load.ledgerSubGroup}
                                          secondName={load.subGroupNameInHindi}
                                        />
                                      </div>
                                      <div className="p-0 text-gray-600 w-32 text-nowrap overflow-x-scroll capitalize custom-scrollbar cursor-pointer">
                                        <ContactMarquee
                                          firstName={load.phone}
                                          secondName={load.address}
                                        />
                                      </div>
                                           <div className="flex my-[2px] px-[2px]">
                                    <span className={`text-xs font-semibold px-2 py-[1px] rounded bg-theme-tableHoverColor text-theme-sidebarBg`}>
                                    Bal: ₹ {Number(load.balance.closing_balance).toLocaleString('en-IN')} {load.balance.closing_balance !== 0 ? `(${load.balance.closing_balance_type})` :""}
                                    </span>
                                </div>
                                    </div>
                                  )}
                                </td>

                                <td className="border-b border-gray-200 text-center text-sm p-0">
                                  {load && (
                                    <>
                                      {load.quantity > 0 && Number(load.quantity).toLocaleString("en-US", { maximumFractionDigits: 0 })}{" "}
                                      {load.quantity > 0 && load.unit} {load.quantity > 0 && load.typeOfBricks?.name} {load.quantity > 0 && " @ "}
                                      {load.quantity > 0 &&  Number(load.rate).toLocaleString("en-US", { maximumFractionDigits: 0 })}
                                      {load.quantity > 0 && load.rate && "/"}
                                      {load.quantity > 0 && Number(load.per_quantity).toLocaleString("en-US", { maximumFractionDigits: 0 })}{" "}
                                      {load.quantity > 0 && " = "}
                                      {load.quantity > 0 && Number(load.total).toLocaleString("en-US", { maximumFractionDigits: 0 })}
                                    </>
                                  )}
                                </td>

                                <td className="border-b border-gray-200 text-center text-sm p-0">
                                  {load && (
                                    <>
                                      {Number(load.paid).toLocaleString("en-US", { maximumFractionDigits: 0 })}{" "}
                                      {load.paid > 0 && load.paymentType && `(${load.paymentType.name})`}
                                    </>
                                  )}
                                </td>
                              </>
                            )}

                            {rowIndex === 0 && (
                              <td
                                rowSpan={maxRows}
                                className="border-b border-s border-e border-gray-200 text-center align-middle"
                              >
                                <div className="flex justify-center gap-2">
                                  <FaEdit
                                    className="text-gray-700 mt-1 cursor-pointer hover:text-theme-btnBg transition-colors"
                                    onClick={async () => {
                                      await handleCancelEdit();
                                      handleEditEntry(entry);
                                    }}
                                    title="Edit ledger"
                                  />
                                  <RiDeleteBin6Fill
                                    className="text-red-700 mt-1 cursor-pointer hover:text-red-800 transition-colors"
                                    title="Delete ledger"
                                    onClick={() => {
                                      setSelectedSales(entry);
                                      setShowDeleteModal(true);
                                    }}
                                  />
                                </div>
                              </td>
                            )}
                          </tr>
                        );
                      });
                    })}
                  </tbody>

                </table>

                {loadingMore && (
                  <div className="flex justify-center py-3">
                    <LoadingSpinner size={30} color="#be8024" />
                  </div>
                )}
              </div>
            </div>
          ) : (
            <p className='text-sm text-gray-500'>{t('noDataAvailable')}</p>
          ))
        }
      </div>

      {showDeleteModal && (
        <DeleteDataModal
          selectedLedger={selectedSales}
          handleDeleteModalClose={() => {
            setShowDeleteModal(false);
            setSelectedSales(null);
          }}
          handleDeleteLedgerApi={handleDeleteSalesApi}
          showinputFields={true}
        />
      )}
    </div>
  );
}